import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mcrit-gestio-calendar-metadata-editor',
  templateUrl: 'calendar-metadata-editor.component.html',
  styleUrls: ['calendar-metadata-editor.component.css']
})
export class CalendarMetadataEditorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
